/* eslint-disable react/prop-types */
import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import {
  Form,
  Modal,
  Row,
  Col,
  Button,
  Alert,
  Spinner,
  ListGroup,
} from "react-bootstrap";
import API from '../../Utility';
import Moment from "react-moment";
import Task from "./Task";

export default function ViewAssignedUsersTasksModal({ workflow, show, user, onCancel, onSuccess }) {
  const [isLoading, setIsLoading] = useState(false);
  const [workflowUser, setWorkflowUser] = useState(false);
  const [workflowUserStatus, setWorkflowUserStatus] = useState(false);

  const { project } = useParams(); // project needed for API
  useEffect(() => {
    async function initializeData() {
      setIsLoading(true);
      const userLookup = await API.get({
        url: `/admin/${project}/workflows/${workflow._id}/users/${user.user._id}?includeUserData=1`,
      });
      setWorkflowUser(userLookup);
      setWorkflowUserStatus(userLookup.workflow.status);
      setIsLoading(false);
    }
    if (show) {
      initializeData();
    }
  }, [show]);

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable={false}
      show={show}
      id="view-assigned-users-tasks-modal"
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          {'All Tasks'}{isLoading ? '' : `: ${workflowUser?.user?.displayName}`}
        </Modal.Title>
      </Modal.Header>
      { isLoading ?
        <Modal.Body>
          <Spinner animation="border" role="status"><span className="sr-only">Loading...</span></Spinner>
        </Modal.Body> :
        <Modal.Body>
          {workflowUser?.user && (
            <div key={workflowUser.user._id}>
              <Row style={{ width: '100%', margin: '0 auto' }}>
                <Col>
                  <Row>
                    <Col>
                      <b>Status</b><br></br>
                      {workflowUserStatus}
                    </Col>
                  </Row>
                  <br></br>
                  <Row>
                    <Col>
                      <b>Description</b><br></br>
                      {workflowUser.workflow.description || 'N/A'}
                    </Col>
                  </Row>
                  <br></br>
                  <Row>
                    <Col>
                      <b>Start Date</b><br></br>
                      {workflowUser.startDate && <Moment format="DD MMM 'YY">{workflowUser.startDate}</Moment>}
                    </Col>
                  </Row>
                  <br></br>
                  <br></br>
                  <Row style={{ margin: '0 auto' }}>
                    <Col>
                      <Row>
                        <Col>
                          {workflowUser?.workflow?.milestones?.map((milestone, milestoneIndex) => {
                            if (milestone?.tasks?.length > 0) {
                              return (
                                <div key={`milestone-${milestoneIndex}`}>
                                  <Row style={{ backgroundColor: '#eee', padding: '20px', borderRadius: '10px' }}>
                                    <b>{milestone.name} - </b>&nbsp; Start Date: &nbsp;<Moment format="DD MMM 'YY" add={{ days: milestone.startDate - 1 }}>{workflowUser.startDate}</Moment>
                                  </Row>
                                  <br></br>
                                  <br></br>
                                  <Row key={`milestone-tasks-${milestoneIndex}`} style={{ padding: '0 0 20px 0' }}>
                                    <Col>
                                      {milestone?.tasks?.filter(task => task.type !== 'message')?.map((task, taskIndex) => {
                                        return (
                                          <Task
                                            key={`task-${task._id}`}
                                            project={project}
                                            workflow={workflow}
                                            workflowUser={workflowUser}
                                            milestoneIndex={milestoneIndex}
                                            taskIndex={taskIndex}
                                            milestone={milestone}
                                            task={task}
                                            setWorkflowUserStatus={setWorkflowUserStatus}
                                          />
                                        );
                                      })}
                                    </Col>
                                  </Row>
                                </div>
                              );
                            } else {
                              return (
                                <div key={`milestone-${milestoneIndex}`}></div>
                              );
                            }
                          })}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <br></br>
            </div>
          )}
        </Modal.Body>
      }
      <Modal.Footer>
        <Row style={{ width: "100%", alignItems: "flex-end" }}>
          <Col style={{ width: "100%", alignItems: "flex-end", textAlign: "right" }}>
            <Button onClick={() => {
              onCancel();
            }} variant="outline-secondary">Close</Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}